function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import MegaMenu from './MegaMenu';
import SimpleMenu from './SimpleMenu';
import { HeaderNavigationStyles } from './HeaderNavigationStyles';
import { prefixLink as _prefixLink } from '../../../../utils';
export default function HeaderNavigation(_ref) {
  var appProps = _ref.appProps,
    navigation = _ref.navigation,
    verticalMenu = _ref.verticalMenu,
    customClass = _ref.customClass;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    headerHeight = _useState2[0],
    setHeaderHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    topHeaderHeight = _useState4[0],
    setTopHeaderHeight = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentHeaderHeight = _useState6[0],
    setCurrentHeaderHeight = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    mainNavHover = _useState8[0],
    setMainNavHover = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    headerRerenderer = _useState10[0],
    setHeaderRerenderer = _useState10[1];
  var frontendStyles = appProps.frontendStyles;
  var currentPath = window.location.pathname;
  useEffect(function () {
    calculateHeaderHeight();
  }, [headerRerenderer]);
  function calculateHeaderHeight() {
    if (document.getElementsByClassName('header_wrapper')[0] != undefined) {
      setHeaderHeight(document.getElementsByClassName('header_wrapper')[0].offsetHeight);
    }
    if (document.getElementsByClassName('top_header')[0] != undefined) {
      setTopHeaderHeight(document.getElementsByClassName('top_header')[0].offsetHeight);
    }
    if (headerHeight && topHeaderHeight) {
      setCurrentHeaderHeight(headerHeight + topHeaderHeight);
    } else {
      setCurrentHeaderHeight(headerHeight);
    }
  }
  function _navigationItemHrefClass(item) {
    return item.children.length > 0 ? 'has_submenu' : '';
  }
  var renderedNavigation = navigation && navigation.items.map(function (item, index) {
    var link = _prefixLink(item, appProps);
    if (link !== null) {
      var itemTranslation = item.translations.find(function (t) {
        return t.locale === appProps.currentLocale;
      });
      var currentNavigationLink = '/' + appProps.currentLocale + itemTranslation.link;
      var linkStyles = {
        fontFamily: frontendStyles.h5styles.fontFamily,
        fontSize: frontendStyles.h5styles.fontSize,
        fontWeight: frontendStyles.h5styles.fontWeight,
        letterSpacing: frontendStyles.h5styles.letterSpacing,
        lineHeight: frontendStyles.h5styles.lineHeight,
        textTransform: frontendStyles.h5styles.textTransform,
        padding: frontendStyles.headerNavigation.padding,
        height: '100%',
        color: currentPath === currentNavigationLink || mainNavHover === item.id ? frontendStyles.headerNavigation.colorHover : frontendStyles.headerNavigation.color,
        backgroundColor: currentPath === currentNavigationLink || mainNavHover === item.id ? frontendStyles.headerNavigation.backgroundHover : frontendStyles.headerNavigation.background
      };
      var navWithLink = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        className: "flex-box items-center ".concat(_navigationItemHrefClass(item), " ").concat(mainNavHover ? 'active' : '', " "),
        style: linkStyles,
        href: link,
        rel: "nofollow noindex noreferrer",
        target: item.openNewPage ? '_blank' : '_self',
        dangerouslySetInnerHTML: {
          __html: itemTranslation.title
        }
      }), customClass && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: frontendStyles.headerNavigation.colorHover
        },
        className: "".concat(customClass)
      }));
      var navNoLink = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "no-link flex-box items-center pointer ".concat(_navigationItemHrefClass(item), " "),
        style: linkStyles,
        dangerouslySetInnerHTML: {
          __html: itemTranslation.title
        }
      }), customClass && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundColor: frontendStyles.headerNavigation.backgroundHover
        },
        className: "".concat(customClass)
      }));
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, item.isMegamenu ? /*#__PURE__*/React.createElement(MegaMenu, {
        appProps: appProps,
        navigation: navigation,
        currentPath: currentPath,
        frontendStyles: frontendStyles,
        currentHeaderHeight: currentHeaderHeight,
        item: item,
        itemTranslation: itemTranslation,
        link: link,
        navWithLink: navWithLink,
        navNoLink: navNoLink,
        navigationItemHrefClass: function navigationItemHrefClass(e) {
          return _navigationItemHrefClass(e);
        },
        prefixLink: function prefixLink(e) {
          return _prefixLink(e, appProps);
        },
        setMainNavHover: setMainNavHover,
        setHeaderRerenderer: setHeaderRerenderer
      }) : /*#__PURE__*/React.createElement(SimpleMenu, {
        appProps: appProps,
        navigation: navigation,
        currentPath: currentPath,
        frontendStyles: frontendStyles,
        currentHeaderHeight: currentHeaderHeight,
        item: item,
        itemTranslation: itemTranslation,
        link: link,
        navWithLink: navWithLink,
        navNoLink: navNoLink,
        navigationItemHrefClass: function navigationItemHrefClass(e) {
          return _navigationItemHrefClass(e);
        },
        prefixLink: function prefixLink(e) {
          return _prefixLink(e, appProps);
        },
        setMainNavHover: setMainNavHover,
        setHeaderRerenderer: setHeaderRerenderer
      }));
    } else {
      return null;
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "header-navigation-wrapper flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-box",
    style: HeaderNavigationStyles.headerNavigationItems
  }, renderedNavigation));
}